import { render, staticRenderFns } from "./MediaActionDelete.vue?vue&type=template&id=0bc0f3c8&"
import script from "./MediaActionDelete.vue?vue&type=script&lang=ts&"
export * from "./MediaActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports